import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-xl font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-dark text-white hover:bg-dark-muted focus:ring-dark',
    secondary: 'bg-pastel-blue-light text-dark hover:bg-pastel-blue focus:ring-pastel-blue',
    outline: 'border-2 border-pastel-grey text-dark hover:border-dark focus:ring-dark',
    ghost: 'bg-transparent text-dark hover:bg-pastel-grey-light focus:ring-pastel-grey'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-5 py-2.5 text-base',
    lg: 'px-8 py-3.5 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button whileTap={{
    scale: disabled || isLoading ? 1 : 0.98
  }} className={`${`${`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} text-[#7C1A32] bg-[#FFD6E0]`} text-[#7C1A32] bg-[#F8E8EE]`} disabled={disabled || isLoading} {...props} data-id="element-47">
      {isLoading ? <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-48">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-49"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-50"></path>
        </svg> : null}
      {children}
    </motion.button>;
}